import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/common-components/styles";

export const StyledInnerWraper = styled(Flex)`
    gap: 8px;

    ${StyledBaseDropdownButtonWrap} {
        flex: none;
        width: auto;
    }
`;
